import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../@core/service/api.service';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { IDropdownOptions, SharedDataService } from '../../@core/service/shared-data.service';
import { IssuerData, CountryCodes } from '../../@models/erp/compilationData';
import { ReportsPrinterComponent } from '../erp/reports/reports-printer/reports-printer.component';
import { ReportsComponent } from '../erp/reports/reports.component';
import { EBusinessType, EContactType } from '../../@models';
import { ActivatedRoute } from '@angular/router';
import { mongoId } from '../../@core/common/global';
import { EventService } from '../../@core/service/eventService';

@Component({
  selector: 'app-openinvoices',
  templateUrl: './openinvoices.component.html',
  styleUrls: ['./openinvoices.component.scss']
})
export class OpeninvoicesComponent implements OnInit, AfterViewInit {

  @ViewChild('reportsPrinter') reportsPrinter: ReportsPrinterComponent;

  search: any;

  customerReferenceOptions = null;
  finishedProductOptions = null;

  finishedProductBusinessId = null;
  finishedProductOptionsMulti = [];

  issuerOptions = IssuerData.getOptions();
  countryOptions = CountryCodes.getOptions();

  employeeOptions: IDropdownOptions[] = [];

  loading = true;

  subscriptions = [];

  filter = {
    issuer: null,
    country: null,
    customers: [],
    customerDocumentNumbers: [],
    finishedProducts: [],
    businessUnits: [],
    relatedSPOs: 2,
    showMarkup: 1,
    sampleRequest: 0,
    manager: null,
  }

  constructor(
    protected data: SharedDataService,
    protected api: ApiService,
    private auth: AuthGuardService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private event: EventService,
  ) { }

  ngOnInit() {

    this.data.loadUsers();
    this.data.loadBusinessUnits();
    this.data.loadBusinesses();
    this.data.loadProducts();
    this.data.loadContacts().then((contacts) => {
      this.employeeOptions = contacts.filter(f => f.business?.type === EBusinessType.NRK && f.type === EContactType.Employee).map(m => ({id: m._id, name: m.displayTitle}))
    })

    this.reload()

  }

  ngAfterViewInit(): void {
    this.loadMessage();
    this.subscriptions.push(this.event.showMessage.subscribe(msg => {
      this.loadMessage(msg);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  async customersChanged(customerIds: string[]) {
    if (customerIds && customerIds.length) {
      this.api.getCustomerDocRefs(customerIds).then(customerRefs =>
        this.customerReferenceOptions = customerRefs.map(m => ({
          id: m.customerDocumentNumber,
          name: `${m.customerDocumentNumber} | ${m.nameOverride || m.code} | ${m.issueDate.split('T')[0]}`,
        })).filter(f => f.id)
      );

      const finishedProducts = await this.api.getCustomerFinishedProducts(customerIds);
      this.finishedProductOptions = finishedProducts.map(m => ({
        id: m._id,
        name: `${m.calcCode} | ${m.calcName} || ${m.externalCode} | ${m.externalName}`,
      }));
    }
  }

  reload() {
    const search = { dueinvoices: JSON.parse(JSON.stringify(ReportsComponent.defaultReport.dueinvoices)) }
    search.dueinvoices.orientation= 'portrait';
    // dateType = DateSelectionData.currentYear.id,
    search.dueinvoices.manager = this.filter.manager; //this.auth.user && this.auth.user.erpRoles && this.auth.user.erpRoles.dashboardType === 1 ? this.auth.user.contact : null;
    search.dueinvoices.issuer = this.filter.issuer;
    search.dueinvoices.country = this.filter.country;
    search.dueinvoices.customers = this.filter.customers;
    search.dueinvoices.customerDocumentNumbers = this.filter.customerDocumentNumbers;
    search.dueinvoices.businessUnits = this.filter.businessUnits;
    search.dueinvoices.finishedProducts = this.filter.finishedProducts;
    search.dueinvoices.filterInternal = true;
    search.dueinvoices.sampleRequest = false;
    search.dueinvoices.limit = 50;
    search.dueinvoices.relatedInvoices = 1; // 1 = not paid, 2 = partially paid, 3 = fully paid
    search.dueinvoices.relatedCreditNotes = 1; // 1 = none 2 = all
    search.dueinvoices.relatedOcs = 1;
    search.dueinvoices.dateFrom = new Date('2016-01-01');
    search.dueinvoices.dateTo = null;
    this.search = search;

    console.log('search', this.search, search, this.search.dueinvoices.customers);
    this.cdRef.detectChanges();
    this.reportsPrinter.reloadData(true);

  }

  reportLoaded() {
    this.loading = false;
    // const code = this.route.snapshot.queryParams.code;
    // if (code) this.reportsPrinter.scrollToDoc(code);
    this.loadMessage();
  }

  async loadMessage(msg = null) {
    const messageId = this.route.snapshot.queryParams.message;
    if (messageId || msg) {
      await this.data.loadWarehousing();
      const message = msg ? msg : this.data.warehousingMessages.find(f => mongoId(f) === messageId);
      // const code = this.route.snapshot.queryParams.code;
      console.log('report loaded', message.code, message);
      if (this.reportsPrinter) {
        this.reportsPrinter.scrollToDoc(message.code);
        this.reportsPrinter.openMessage(message);
      }
    }
  }


}
